import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GeneralLedgerService } from '../../../../../services/general-ledger.service';
import {
  GeneralLedgerExportTypes,
  GLConfiguration,
  GlMappingGroup,
  GlQboAccount
} from '../../../../../models/general-ledger';
import { ClientSelectionState } from '../../../../../state/ClientSelectionState/ClientSelection.state';
import { mergeMap } from 'rxjs/operators';
import { CheckboxSizes } from '../../../../../components/checkbox/checkbox.component';
import {
  GeneralLedgerState,
  GlDoExport,
  GlLoadConfigs,
  GlTabChanged
} from '../../../../../state/GeneralLedgerState/GeneralLedger.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-gl-checks-mapping',
  templateUrl: './gl-checks-mapping.component.html',
  styleUrls: ['./gl-checks-mapping.component.css'],
  standalone: false
})
export class GlChecksMappingComponent implements OnInit {
  @Output()
  finished = new EventEmitter<any>();
  @Input()
  config: GLConfiguration;
  @Select(GeneralLedgerState.getBalance)
  balance: Observable<number | null>;
  @Select(GeneralLedgerState.getQboAccounts)
  public qboAccounts: Observable<GlQboAccount[]>;
  mappings: GlMappingGroup;
  public glAccount: string = null;
  public offset: string = null;
  private clientCode: string;
  private groupId: number | null = null;
  constructor(
    private store: Store,
    private glService: GeneralLedgerService
  ) {}

  ngOnInit() {
    this.glAccount = this.config.GLAccount;
    this.offset = this.config.Offset;
    this.store
      .selectOnce(ClientSelectionState.clientCode)
      .pipe(
        mergeMap(code => {
          this.clientCode = code;
          return this.glService.getGlCheckCategories(code);
        })
      )
      .subscribe(x => {
        this.mappings = x;
        //Check if there are already mappings for this config.
        this.glService.getGlMappingGroups(this.clientCode, this.config.Id).subscribe(groups => {
          if (groups.length > 0) {
            const group = groups[0];
            this.groupId = group.Id;
            this.mappings.Rows.forEach(row => {
              const savedRow = group.Rows.find(x => x.TypeName == row.TypeName);
              row.CheckName = savedRow?.CheckName;
              row.CheckNumber = savedRow?.CheckNumber;
              row.NotExported = savedRow?.NotExported ?? false;
            });
          }
        });
      });
  }

  toggleNotExported(val, mapping) {
    mapping.NotExported = !val;
  }
  public cancel() {
    this.finished.emit(null);
  }
  public submit() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      //Because the config is saved in the store, it's not directly mutable. Make a deep copy.
      const clone: GLConfiguration = structuredClone(this.config);
      //Start by updating the GLConfiguration with the two new fields
      clone.GLAccount = this.glAccount;
      clone.Offset = this.offset;
      this.mappings.Id = this.groupId;
      this.mappings.ConfigurationId = clone.Id;
      this.mappings.Rows.forEach(row => {
        if (row.NotExported == null) {
          row.NotExported = false;
        }
        row.IsDefault = false;
        row.IsOffset = false;
      });
      this.glService.updateGlConfiguration(code, clone).subscribe(_ => {
        if (this.groupId != null) {
          this.glService
            .updateGlMappingGroup(code, clone.Id, this.groupId, this.mappings)
            .subscribe(_ => {
              this.store.dispatch(new GlLoadConfigs()).subscribe(_ => {
                this.finished.emit(clone);
              });
            });
        } else {
          this.glService.createGlMappingGroups(code, clone.Id, [this.mappings]).subscribe(_ => {
            this.store.dispatch(new GlLoadConfigs()).subscribe(_ => {
              this.finished.emit(clone);
            });
          });
        }
      });
    });
  }

  protected readonly CheckboxSizes = CheckboxSizes;
  protected readonly GeneralLedgerExportTypes = GeneralLedgerExportTypes;
}
